import image1 from "/Users/nikkylu/lumed/src/pages/components/blade.fld/image001.jpg";
import image2 from "/Users/nikkylu/lumed/src/pages/components/blade.fld/image002.jpg";
import image3 from "/Users/nikkylu/lumed/src/pages/components/blade.fld/image003.jpg";
import image4 from "/Users/nikkylu/lumed/src/pages/components/blade.fld/image004.jpg";
import image5 from "/Users/nikkylu/lumed/src/pages/components/blade.fld/image005.jpg";
import image6 from "/Users/nikkylu/lumed/src/pages/components/blade.fld/image006.jpg";
import image7 from "/Users/nikkylu/lumed/src/pages/components/blade.fld/image007.jpg";
import image8 from "/Users/nikkylu/lumed/src/pages/components/blade.fld/image008.jpg";
import image9 from "/Users/nikkylu/lumed/src/pages/components/blade.fld/image009.png";
import image10 from "/Users/nikkylu/lumed/src/pages/components/blade.fld/image010.jpg";
import image11 from "/Users/nikkylu/lumed/src/pages/components/blade.fld/image011.jpg";
import image12 from "/Users/nikkylu/lumed/src/pages/components/blade.fld/image012.jpg";
import image13 from "/Users/nikkylu/lumed/src/pages/components/blade.fld/image013.jpg";
import image14 from "/Users/nikkylu/lumed/src/pages/components/blade.fld/image014.jpg";
import image15 from "/Users/nikkylu/lumed/src/pages/components/blade.fld/image015.jpg";
import image16 from "/Users/nikkylu/lumed/src/pages/components/blade.fld/image016.jpg";
import image17 from "/Users/nikkylu/lumed/src/pages/components/blade.fld/image017.jpg";
import image18 from "/Users/nikkylu/lumed/src/pages/components/blade.fld/image018.jpg";
import image19 from "/Users/nikkylu/lumed/src/pages/components/blade.fld/image019.jpg";
import image20 from "/Users/nikkylu/lumed/src/pages/components/blade.fld/image020.jpg";

import "./Home.css"

const Blade = () => {
  return (
<div className="Home">
    <div>Surgical Blades, Scalpels, Sutures, Sterilization Swabs etc.</div>
    <div className="Home-con">
    <div className="Home-sl">
        Surgical Blades, Saclpels, and Sutures
    </div></div>
    <div className="Home-con">
    <img src={image1} className="Home-sp"/>
    <div className="Home-s">
        <div>Disposable Surgical Blades</div>
        <p>sterile, ISO 7740, CE</p>
        <p>type: carbon steel / stainless steel blades, various sizes</p>
    </div>
</div>

<div className="Home-con">
    <img src={image2} className="Home-sp"/>
    <div className="Home-s">
        <div>Disposable Surgical Scalpels</div>
        <p>sterile, ISO 7740, CE</p>
        <p>usual or safety type, carbon steel / stainless steel blades,</p>
        <p>with plastic handle and cap, various sizes</p>
    </div>
</div>

<div className="Home-con">
    <img src={image3} className="Home-sp"/>
    <div className="Home-s">
        <div>Surgical Scissors</div>
        <p>stainless steel, various sizes</p>
    </div>
</div>

<div className="Home-con">
    <img src={image4} className="Home-sp"/>
    <div className="Home-s">
        <div>Surgical Forceps</div>
        <p>stainless steel, various sizes</p>
    </div>
</div>

<div className="Home-con">
    <img src={image5} className="Home-sp"/>
    <div className="Home-s">
        <div>Handles for Surgical Blades</div>
        <p>ISO 7740, CE</p>
        <p>stainless steel, size 3 or size 4</p>
    </div>
</div>

<div className="Home-con">
    <img src={image6} className="Home-sp"/>
    <div className="Home-s">
        <div>Disposable Skin Stapler</div>
        <p>sterile, CE</p>
        <p>ABS handle, with disposable stainless-steel staples</p>
    </div>
</div>

<div className="Home-con">
    <img src={image7} className="Home-sp"/>
    <div className="Home-s">
        <div>Disposable Skin Stapler Remover</div>
        <p>stainless steel, with ABS handle</p>
    </div>
</div>

<div className="Home-con">
    <img src={image8} className="Home-sp"/>
    <div className="Home-s">
        <div>Disposable Cord Clamp</div>
        <p>sterile</p>
    </div>
</div>

<div className="Home-con">
    <img src={image9} className="Home-sp"/>
    <div className="Home-s">
        <div>Surgical Sutures</div>
        <p>sterile, USP/BP, CE</p>
        <p>usual quality or premium quality,</p>
        <p>various absorbable or non-absorbable sutures, with or without needles</p>
    </div>
</div>

<div className="Home-con">
    {/* <img src={image10} className="Home-sp"/> */}
    <div className="Home-sl">
        <div>Sterilization Swabs</div>
    </div>
</div>

<div className="Home-con">
    <img src={image10} className="Home-sp"/>
    <div className="Home-s">
        <div>Alcohol Prep Swabs</div>
        <p>CE</p>
        <p>non-woven pads saturated with 70% isopropyl alcohol, various sizes</p>
    </div>
</div>

<div className="Home-con">
    <img src={image11} className="Home-sp"/>
    <div className="Home-s">
        <div>Alcohol Wipes</div>
        <p>in barrel</p>
        <p>commercial grade disinfectant, saturated with 70% isopropyl alcohol</p>
    </div>
</div>

<div className="Home-con">
    <img src={image12} className="Home-sp"/>
    <div className="Home-s">
        <div>Povidone-lodine Prep Pad</div>
        <p>CE</p>
        <p>non-woven pads saturated with povidone-lodine, various sizes</p>
    </div>
</div>

<div className="Home-con">
    <img src={image13} className="Home-sp"/>
    <div className="Home-s">
        <div>Povidone-lodine Paint(solution)</div>
    </div>
</div>

<div className="Home-con">
    <img src={image14} className="Home-sp"/>
    <div className="Home-s">
        <div>Alcohol Swabsticks</div>
        <p>absorbent cotton buds, saturated with 70% isopropyl alcohol</p>
        <p>with wooden or plastic applicator</p>
    </div>
</div>

<div className="Home-con">
    <img src={image15} className="Home-sp"/>
    <div className="Home-s">
        <div>Povidone-lodine Swabsticks</div>
        <p>absorbent cotton buds, saturated with povidone-lodine</p>
        <p>with wooden or plastic applicator</p>
    </div>
</div>

<div className="Home-con">
    <img src={image16} className="Home-sp"/>
    <div className="Home-s">
        <div>Cleaning Swab</div>
        <p>absorbent cotton pad, saturated with 2% chlorhexidine and 75% isopropyl alcohol</p>
        <p>for cleaning and sterilization in hands, skin, medical devices, needle-less infusion connector</p>
    </div>
</div>

<div className="Home-con">
    <img src={image17} className="Home-sp"/>
    <div className="Home-s">
        <div>Protective Wipe</div>
        <p>isopropyl alcohol, butyl ester of PVM/MA copolymer, acetyl tribtyl citrate</p>
        <p>for applying on skin to appear the blood vessel on the skin for infusion or transfusion</p>
    </div>
</div>

<div className="Home-con">
    <img src={image18} className="Home-sp"/>
    <div className="Home-s">
        <div>Adhesive Tape Remover Pad</div>
        <p>non-woven pads, saturated with mineral oil, fragrance, PEG98(lanolin)</p>
    </div>
</div>

<div className="Home-con">
    <img src={image19} className="Home-sp"/>
    <div className="Home-s">
        <div>Cleansing Towelette</div>
        <p>non-woven pads, saturated with 70% isopropyl alcohol</p>
    </div>
</div>

<div className="Home-con">
    <img src={image20} className="Home-sp"/>
    <div className="Home-s">
        <div>Nailpolish Remover Wipe</div>
    </div>
</div>



        </div>
   
  )
}

export default Blade;